export default "__VITE_ASSET__CDhy1T3I__"